{
  "groups": {
    "referenceNumber": "Nomor Referensi",
    "appointmentStartTimes": "Waktu Mulai Janji Temu",
    "appointmentNotifications": "Notifikasi Janji Temu",
    "appointmentStatuses": "Status Janji Temu",
    "customAppointmentsGrid": "Kisi Janji Temu Kustom",
    "limiter": "Pembatas",
    "schedulingPortal": "Portal Penjadwalan",
    "dockSelection": "Pemilihan Dok",
    "timeDisplay": "Tampilan Waktu",
    "gateManagement": "Manajemen Gerbang",
    "smartGate": "SmartGate",
    "idValidation": "Validasi ID",
    "appointmentValidation": "Validasi Janji Temu",
    "other": "Lainnya",
    "handlingUnits": "Unit Penanganan"
  },
  "groupDescriptions": {
    "referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment": "Nomor Referensi adalah referensi yang dapat Anda minta dari pengangkut saat mereka menjadwalkan janji temu.",
    "determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart": "Tentukan interval waktu dimulainya janji temu yang diperbolehkan.",
    "manageAllTypesOfAppointmentNotificationsForThisEntity": "Kelola semua jenis notifikasi janji temu untuk {entity} ini.",
    "manageTheSchedulingPortalSettingsForThisEntity": "Kelola pengaturan Portal Penjadwalan untuk {entity} ini",
    "handlingUnitsIsANumericFieldForRequestingUnitsEGPalletsDuringAppointmentSchedulingAddItToYourFormToAlsoEnableTheLimiterFeature": "Unit Penanganan adalah kolom angka untuk meminta jumlah unit (mis. palet) saat penjadwalan janji temu. Tambahkan ke formulir Anda untuk sekaligus mengaktifkan fitur Pembatas.",
    "theLimiterAllowsYouToSetAMaximumNumberOfAppointmentsOrHandlingUnitsEGPalletsThatCanBeScheduledPerDay": "Pembatas memungkinkan Anda menetapkan jumlah maksimum janji temu atau unit penanganan (mis. palet) yang dapat dijadwalkan per hari."
  },
  "labels": {
    "minimumAmountOfReferenceNumbers": "Jumlah Minimum Nomor Referensi",
    "maximumAmountOfReferenceNumbers": "Jumlah Maksimum Nomor Referensi",
    "includeReferenceNumberFieldOnAllAppointmentForms": "Sertakan kolom Nomor Referensi di semua formulir janji temu?",
    "referenceNumberFieldName": "Nama kolom Nomor Referensi",
    "referenceNumberHelperText": "Teks bantuan Nomor Referensi",
    "makeReferenceNumberARequiredField": "Jadikan Nomor Referensi sebagai kolom wajib?",
    "allowAppointmentsForThisEntityToStartAt": "Izinkan janji temu untuk {entity} ini dimulai pada:",
    "enableAppointmentNotificationsForThisEntity": "Aktifkan notifikasi janji temu untuk {entity} ini?",
    "selectEachDesiredStartTimeIndividually": "Pilih setiap waktu mulai yang diinginkan satu per satu",
    "hideTheLoadTypeDuration": "Sembunyikan durasi jenis muatan?",
    "uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications": "Unggah logo {entity} Anda untuk ditampilkan di Portal Penjadwalan dan di semua notifikasi email",
    "uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal": "Unggah peta yard gudang Anda untuk ditampilkan di Portal Penjadwalan",
    "statusForNewlyCreatedAppointments": "Status untuk janji temu yang baru dibuat",
    "muteAppointmentNotifications": "Bisukan Notifikasi Janji Temu",
    "allowDockSelectionInSchedulingPortal": "Izinkan pemilihan Dok di Portal Penjadwalan?",
    "theStatusThatFollowsArrivedIs": "Status setelah 'Tiba' adalah",
    "displayTimeIn": "Tampilkan waktu dalam:",
    "customizeAppointmentDetails": "Sesuaikan detail janji temu",
    "gridTileConfig": "Konfigurasi ubin kisi",
    "enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation": "Terapkan geofencing untuk mewajibkan pengemudi memberikan lokasi real-time mereka",
    "wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional": "Apakah Anda ingin menampilkan informasi tambahan kepada pengemudi setelah mereka check-in? (opsional)",
    "preventReschedulingAppointmentsInTheSchedulingPortal": "Cegah penjadwalan ulang janji temu di Portal Penjadwalan?",
    "revertToRequestedOnCarrierReschedule": "Kembalikan ke Diminta saat pengangkut menjadwalkan ulang",
    "observationMatchAttribute": "Atribut Pencocokan Observasi",
    "observationMatchTimeWindow": "Rentang Waktu Pencocokan Observasi",
    "autoDepartAssets": "Keberangkatan Aset Otomatis",
    "autoCreateAssets": "Pembuatan Aset Otomatis",
    "gateFeedColumns": "Kolom Gate Feed",
    "checkInEarlyThreshold": "Batas Check-in Lebih Awal",
    "checkInLateThreshold": "Batas Check-in Terlambat",
    "technicalContactEmailAddress": "Alamat Email Kontak Teknis",
    "technicalContactEmailThrottleMinutes": "Jeda Email Kontak Teknis (Menit)",
    "requireUniqueReferenceNumbers": "Wajibkan Nomor Referensi Unik",
    "appointmentStartTimeInterval": "Interval Waktu Mulai Janji Temu",
    "referenceNumberInputMode": "Mode Input Nomor Referensi",
    "uploadWarehouseYardMap": "Unggah peta yard gudang Anda untuk ditampilkan di Portal Penjadwalan",
    "includeHandlingUnitsFieldOnAllAppointmentForms": "Sertakan kolom Unit Penanganan di semua formulir janji temu?",
    "handlingUnitsLabel": "Label Unit Penanganan",
    "handlingUnitsHelperText": "Teks Bantuan Unit Penanganan",
    "makeHandlingUnitsARequiredField": "Jadikan Unit Penanganan sebagai kolom wajib?",
    "maximumHandlingUnitsValueForAnAppointment": "Nilai maksimum Unit Penanganan untuk janji temu",
    "minimumHandlingUnitsValueForAnAppointment": "Nilai minimum Unit Penanganan untuk janji temu",
    "checkOutBolSignedRequired": "BOL Bertanda Tangan Wajib saat Check-out",
    "checkOutBolNotLoadingErrorMessage": "Pesan kesalahan saat BOL check-out tidak dapat dimuat",
    "checkOutIdentifier": "Pengenal Check-out",
    "enableCheckInIdValidationPersona": "Aktifkan validasi ID saat check-in (Persona)",
    "requireCheckInIdValidationToCompleteCheckIn": "Wajibkan validasi ID untuk menyelesaikan check-in",
    "checkInIdValidationTemplate": "Templat validasi ID check-in",
    "geofenceRadius": "Radius Geofence",
    "createAppointmentOnExternalValidationFailure": "Buat janji temu meskipun validasi eksternal gagal",
    "enableOverrideLimiterFunction": "Aktifkan Fungsi Pengabaian Pembatas",
    "receiveUnplannedCheckInEmailNotifications": "Terima Notifikasi Email Check-in Tidak Terencana",
    "driversMustEnterAReferenceNumberToCheckIn": "Pengemudi wajib memasukkan nomor referensi untuk check-in",
    "driversCanOnlyCheckInIfTheReferenceNumberMatchesTheScheduledAppointment": "Pengemudi hanya dapat check-in jika nomor referensi cocok dengan janji temu yang dijadwalkan",
    "driversSkipTheReferenceNumberStepDuringCheckIn": "Pengemudi melewati langkah nomor referensi saat check-in",
    "customizeTheFirstSmsMessageDriversReceiveAfterCheckInOptional": "Sesuaikan pesan SMS pertama yang diterima pengemudi setelah check-in (opsional)",
    "includeYardMapImageInTheFirstCheckInSms": "Sertakan gambar Peta Yard dalam SMS check-in pertama?",
    "automaticallyDeleteStoredIdValidations": "Hapus otomatis validasi ID yang tersimpan",
    "deleteStoredIdValidationsAfter": "Hapus validasi ID yang tersimpan setelah",
    "displayDatesAs": "Tampilkan tanggal sebagai:",
    "displayTimeAs": "Tampilkan waktu sebagai:"
  },
  "descriptions": {
    "requireAtLeastThisAmountOfReferenceNumbersForAnAppointment": "Wajibkan setidaknya jumlah nomor referensi ini untuk sebuah janji temu",
    "requireAtMostThisAmountOfReferenceNumbersForAnAppointment": "Batasi paling banyak jumlah nomor referensi ini untuk sebuah janji temu",
    "theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId": "Nama tampilan untuk kolom Nomor Referensi. Mis.: \"Nomor PO\", \"ID Pengiriman\"",
    "additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx": "Informasi tambahan untuk membantu mengisi kolom Nomor Referensi.  Mis.: \"Nomor Referensi harus diawali dengan OD-XX\"",
    "requireTheReferenceNumberForAllAppointmentsBeingScheduled": "Wajibkan Nomor Referensi untuk semua janji temu yang dijadwalkan",
    "thisOnlyAffectsNewlyCreatedAppointments": "Ini hanya berlaku untuk janji temu yang baru dibuat",
    "theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal": "Durasi ditampilkan pada daftar pilihan Jenis Muatan saat membuat janji temu di Portal Penjadwalan",
    "allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal": "Izinkan pemilihan Dok saat membuat janji temu di Portal Penjadwalan",
    "thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted": "Pengaturan ini memungkinkan pilihan status alternatif 'Dalam Proses' di antara 'Tiba' dan 'Selesai'",
    "determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports": "Tentukan cara waktu ditampilkan di seluruh platform untuk semua pengguna Org ini, termasuk kisi janji temu dan laporan.",
    "enableToSwitchToTheNewCustomizableAppointmentDetailsSystem": "Aktifkan untuk beralih ke sistem detail janji temu baru yang dapat disesuaikan",
    "userConfigurationOfHowGridTilesWillBeDisplayed": "Konfigurasi pengguna untuk cara ubin kisi ditampilkan.",
    "thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse": "Pengaturan ini meminta lokasi pengemudi dan mencegah mereka check-in jika berada lebih dari satu mil dari gudang Anda.",
    "preventCarriersFromReschedulingAppointmentsOptional": "Cegah pengangkut menjadwalkan ulang janji temu. (opsional)",
    "whenACarrierReschedulesAScheduledAppointmentMoveItBackToRequestedForReApproval": "Saat pengangkut menjadwalkan ulang janji temu yang Terjadwal, kembalikan statusnya ke Diminta untuk persetujuan ulang",
    "attributeToBeUsedForMatchingObservations": "Atribut yang digunakan untuk mencocokkan observasi",
    "theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime": "Jumlah menit sebelum dan sesudah waktu check-in yang diperhitungkan untuk sebuah observasi",
    "theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn": "Jumlah menit sebelum waktu mulai janji temu saat pengangkut dapat check-in",
    "theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn": "Jumlah menit setelah waktu mulai janji temu saat pengangkut masih dapat check-in",
    "emailAddressWhereTechnicalIssuesAndInformationWillBeSent": "Alamat email tujuan pengiriman masalah dan informasi teknis",
    "theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs": "Jeda waktu antar-notifikasi yang dikirim ke kontak teknis saat terjadi kesalahan server validasi.",
    "aListOfMutedAppointmentNotifications": "Daftar notifikasi janji temu yang dibisukan.",
    "requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled": "Wajibkan Nomor Referensi unik untuk semua janji temu yang dijadwalkan",
    "thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart": "Ini adalah interval menit antar-waktu mulai janji temu",
    "enableTheCustomAppointmentStartTimesSetting": "Aktifkan pengaturan waktu mulai janji temu kustom",
    "theInputModeForTheReferenceNumberField": "Mode input untuk kolom nomor referensi",
    "theDisplayNameForTheUnitTypeFieldEgPalletCountSkidCount": "Nama tampilan untuk kolom jenis unit. Mis.: Jumlah Palet, Jumlah Skid",
    "requireTheUnitTypeFieldForAllAppointmentsBeingScheduled": "Wajibkan kolom jenis unit untuk semua janji temu yang dijadwalkan",
    "autoDepartAssetsOnReceivingOutgateEvent": "Berangkatkan aset secara otomatis saat menerima peristiwa gerbang keluar",
    "autoCreateAssetsOnReceivingIngateEvent": "Buat aset secara otomatis saat menerima peristiwa gerbang masuk",
    "columnsAvailableOnTheAiGateFeedPageRequiredColumnsAreAlwaysShown": "Kolom yang tersedia di halaman AI Gate Feed. Kolom wajib selalu ditampilkan.",
    "createAppointmentsEvenIfAppointmentValidationDoesNotPass": "Buat janji temu meskipun validasi janji temu tidak lolos",
    "theRadiusInMilesThatTheDriverMustBeWithinToCheckInThisIsOnlyApplicableIfGeofencingIsEnabled": "Radius dalam mil tempat pengemudi harus berada untuk dapat check-in. Ini hanya berlaku jika geofencing diaktifkan.",
    "additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeOnlyNumbers": "Informasi tambahan untuk membantu mengisi kolom jenis unit. Mis.: Jenis Unit hanya boleh berisi angka",
    "setsTheMaximumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "Menetapkan nilai angka maksimum yang dapat dimasukkan pada kolom Unit Penanganan di janji temu",
    "setsTheMinimumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "Menetapkan nilai angka minimum yang dapat dimasukkan pada kolom Unit Penanganan di janji temu",
    "whenTheLimiterIs100ReachedThisFeatureAllowsOnlyWarehouseUsersToOverrideAndCreateOrApproveAppointmentsAndUnits": "Saat pembatas mencapai 100%, fitur ini hanya mengizinkan pengguna gudang untuk mengabaikan batas dan membuat atau menyetujui janji temu dan unit",
    "theAssetAttributeTheSystemWillUseToValidateTheCheckOutForm": "Atribut aset yang akan digunakan sistem untuk memvalidasi formulir check-out",
    "enforceBolSigningOnCheckOutForm": "Wajibkan penandatanganan BOL pada formulir check-out",
    "errorMessageShownToDriversWhenTheBolFailsToLoadDuringCheckOut": "Jika BOL tidak tersedia, pengangkut tidak dapat menandatanganinya sehingga check-out akan terhambat. Di sini, Anda dapat mengatur instruksi khusus yang akan dilihat pengemudi jika hal ini terjadi.",
    "showThePersonaComponentInTheCheckInFlowForIdentityVerification": "Tampilkan komponen Persona dalam alur check-in untuk verifikasi identitas",
    "requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn": "Wajibkan validasi Persona yang berhasil sebelum pengemudi dapat menyelesaikan check-in",
    "personaTemplateUsedForCheckInIdentityVerification": "Templat Persona yang digunakan untuk verifikasi identitas saat check-in",
    "warehouseSubscribersReceiveEmailNotificationsWhenAnUnplannedCheckInOccurs": "Pelanggan gudang menerima notifikasi email saat terjadi check-in tidak terencana",
    "thisMessageReplacesTheDefaultCheckInConfirmationTextSentToTheDriverBySmsLeaveBlankToUseTheDefaultMessage": "Pesan ini menggantikan teks konfirmasi check-in default yang dikirim ke pengemudi melalui SMS. Biarkan kosong untuk menggunakan pesan default.",
    "sendsYourYardMapAsASeparateImageMessageRightAfterTheCheckInSmsRequiresAYardMapToBeUploadedForThisWarehouse": "Mengirim Peta Yard Anda sebagai pesan gambar terpisah segera setelah SMS check-in. Memerlukan Peta Yard yang telah diunggah untuk gudang ini.",
    "storedIdValidationRecordsArePermanentlyDeletedOnceTheRetentionPeriodHasPassed": "Data validasi ID yang tersimpan akan dihapus secara permanen setelah masa retensi berakhir",
    "numberOfDaysAStoredIdValidationIsKeptBeforeItIsDeleted": "Jumlah hari validasi ID yang tersimpan disimpan sebelum dihapus",
    "determineHowDatesWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "Tentukan cara tanggal ditampilkan bagi pengguna perusahaan ini di seluruh tampilan yang digunakan perusahaan.",
    "determineHowTimeWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "Tentukan cara waktu ditampilkan bagi pengguna perusahaan ini di seluruh tampilan yang digunakan perusahaan."
  },
  "placeholders": {
    "referenceNumberAssociatedWithAppointment": "Nomor Referensi yang terkait dengan janji temu",
    "insertMessageHere": "Masukkan pesan di sini"
  },
  "dropdownOptions": {
    "allowAppointmentsForThisEntityToStartAt": {
      "topOfTheHour00": "Awal jam (:00)",
      "topAndBottomOfTheHour00And30": "Awal dan pertengahan jam (:00 dan :30)",
      "everyTwentyMinutes0020And40": "Setiap Dua Puluh Menit (:00, :20, dan :40)",
      "everyQuarterOfTheHour001530And45": "Setiap seperempat jam (:00, :15, :30, dan :45)",
      "customStartTimes": "Waktu mulai kustom"
    },
    "appointmentStartTimeInterval": {
      "15Minutes": "15 Menit",
      "30Minutes": "30 Menit",
      "60Minutes": "60 Menit",
      "90Minutes": "90 Menit"
    },
    "observationMatchAttribute": {
      "licensePlate": "Pelat Nomor",
      "dotNumber": "Nomor DOT",
      "any": "Apa Saja",
      "cascade": "Bertingkat"
    },
    "referenceNumberInputMode": {
      "alphanumeric": "Alfanumerik",
      "numeric": "Numerik"
    },
    "statusForNewlyCreatedAppointments": {
      "scheduled": "Terjadwal",
      "requested": "Diminta"
    },
    "theStatusThatFollowsArrivedIs": {
      "inProgress": "Dalam Proses",
      "completed": "Selesai"
    },
    "includeReferenceNumberFieldOnAllAppointmentForms": {
      "noDontIncludeTheReferenceNumberField": "Tidak, jangan sertakan kolom Nomor Referensi",
      "yesIncludeTheReferenceNumberField": "Ya, sertakan kolom Nomor Referensi"
    },
    "hideTheLoadTypeDuration": {
      "noDontHideTheLoadTypeDuration": "Tidak, jangan sembunyikan durasi Jenis Muatan",
      "yesHideTheLoadTypeDuration": "Ya, sembunyikan durasi Jenis Muatan"
    },
    "enableAppointmentNotificationsForThisEntity": {
      "noDisableAppointmentNotifications": "Tidak, nonaktifkan notifikasi janji temu",
      "yesEnableAppointmentNotifications": "Ya, aktifkan notifikasi janji temu"
    },
    "allowDockSelectionInSchedulingPortal": {
      "noDontAllowDockSelection": "Tidak, jangan izinkan pemilihan Dok",
      "yesAllowTheDockSelection": "Ya, izinkan pemilihan Dok"
    },
    "displayTimeIn": {
      "regularTime12Hour": "Format biasa (12 jam)",
      "militaryTime24Hour": "Format 24 jam"
    },
    "preventReschedulingAppointmentsInTheSchedulingPortal": {
      "allowReschedulingInTheSchedulingPortal": "Izinkan penjadwalan ulang di Portal Penjadwalan ",
      "preventReschedulingInTheSchedulingPortal": "Cegah penjadwalan ulang di Portal Penjadwalan"
    },
    "revertToRequestedOnCarrierReschedule": {
      "revertToRequestedOnCarrierReschedule": "Kembalikan ke Diminta saat pengangkut menjadwalkan ulang",
      "keepStatusUnchangedOnCarrierReschedule": "Pertahankan status saat pengangkut menjadwalkan ulang"
    },
    "makeReferenceNumberARequiredField": {
      "noDontMakeReferenceNumberARequiredField": "Tidak, jangan jadikan Nomor Referensi sebagai kolom wajib",
      "yesMakeReferenceNumberARequiredField": "Ya, jadikan Nomor Referensi sebagai kolom wajib"
    },
    "requireUniqueReferenceNumbers": {
      "noDontRequireUniqueReferenceNumbers": "Tidak, jangan wajibkan Nomor Referensi unik",
      "yesRequireUniqueReferenceNumbers": "Ya, wajibkan Nomor Referensi unik"
    },
    "makeHandlingUnitsARequiredField": {
      "noDontMakeHandlingUnitsARequiredField": "Tidak, jangan jadikan Unit Penanganan sebagai kolom wajib",
      "yesMakeHandlingUnitsARequiredField": "Ya, jadikan Unit Penanganan sebagai kolom wajib"
    },
    "includeHandlingUnitsFieldOnAllAppointmentForms": {
      "noDontIncludeTheHandlingUnitsField": "Tidak, jangan sertakan kolom Unit Penanganan",
      "yesIncludeTheHandlingUnitsField": "Ya, sertakan kolom Unit Penanganan"
    },
    "checkOutIdentifier": {
      "licensePlate": "Pelat Nomor",
      "phoneNumber": "Nomor Telepon",
      "any": "Apa Saja"
    },
    "enableCheckInIdValidationPersona": {
      "no": "Tidak",
      "yes": "Ya"
    },
    "requireCheckInIdValidationToCompleteCheckIn": {
      "no": "Tidak",
      "yes": "Ya"
    },
    "checkInIdValidationTemplate": {
      "driverLicenseFront1Retry": "SIM pengemudi - Depan - 1 kali percobaan ulang",
      "driverLicenseFrontBarcodeFaceUsOnly1Retry": "SIM pengemudi - Depan, kode batang, wajah, khusus AS, 1 kali percobaan ulang"
    },
    "receiveUnplannedCheckInEmailNotifications": {
      "no": "Tidak",
      "yes": "Ya"
    },
    "displayDatesAs": {
      "mmDdYyyy": "BB/HH/TTTT",
      "ddMmYyyy": "HH/BB/TTTT",
      "yyyyMmDd": "TTTT-BB-HH",
      "tueMmDdYyyy": "Sel, BB/HH/TTTT",
      "tueDdMmYyyy": "Sel, HH/BB/TTTT",
      "tueYyyyMmDd": "Sel, TTTT-BB-HH"
    },
    "displayTimeAs": {
      "12HourEG700Am": "12 jam (mis. 7:00 AM)",
      "24HourEG0700": "24 jam (mis. 07:00)"
    }
  },
  "examples": {
    "displayTimeIn": {
      "eG700Am700Pm": "Mis. 7:00 AM / 7:00 PM",
      "eG07001900": "Mis. 07:00 / 19:00"
    }
  },
  "notes": {
    "notesPrefix": "Catatan:",
    "ifLeftEmptyTheDefaultNameWillBeApplied": "Jika dibiarkan kosong, nama default akan digunakan",
    "ifLeftEmptyTheDefaultHelperTextWillBeApplied": "Jika dibiarkan kosong, teks bantuan default akan digunakan",
    "enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually": "Mengaktifkan opsi ini tidak memengaruhi notifikasi yang sudah dinonaktifkan secara individual di tingkat janji temu.",
    "ifLeftEmptyNoNotificationsWillBeSent": "Jika dibiarkan kosong, tidak ada notifikasi yang akan dikirim",
    "referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments": "Nomor referensi yang ditetapkan pada janji temu yang dibatalkan atau tidak hadir dapat digunakan kembali pada janji temu baru",
    "ifEmptyTheDefaultNameWillBeApplied": "Jika kosong, nama default akan digunakan"
  },
  "links": {},
  "sectionLabels": {
    "drivers": "Pengemudi",
    "checkInSms": "SMS Check-in",
    "dataRetention": "Retensi Data"
  }
}
